import { useCallback, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { 
    monitorFilterTypeState, 
    pageState, 
    teamIdState, 
    challengeIdState 
} from "../monitor/Monitor.state";
import { 
    categoryState, 
    pageState as dashboardPageState, 
    pageSizeState as dashboardPageSizeState, 
} from '../dashboard/Dashboard.state';
import {
    pageState as challengesPageState,
    pageSizeState as challengesPageSizeState,
    termState,
} from '../organize/Organize.state'
import {
    pageState as teamsPageState,
    pageSizeState as teamsPageSizeState,
} from '../teams/Teams.state'
import { metricState, styleState } from '../monitor/Leaderboard.state';
import { useResetRecoilState } from 'recoil';

const useRouteChange = ({ onRouteChange }) => {
  const location = useLocation();
  const resetTeamState = useResetRecoilState(teamIdState);
  const resetChallengeState = useResetRecoilState(challengeIdState);
  const resetFilterTypeState = useResetRecoilState(monitorFilterTypeState);
  const resetCategoryState = useResetRecoilState(categoryState);
  const resetMonitorPageState = useResetRecoilState(pageState);
  const resetDashboardPageState = useResetRecoilState(dashboardPageState)
  const resetDashboardPageSizeState = useResetRecoilState(dashboardPageSizeState)
  const resetLeaderboardStyleState = useResetRecoilState(styleState)
  const resetLeaderboardMetricState = useResetRecoilState(metricState)
  const resetChallengePageState = useResetRecoilState(challengesPageState)
  const resetChallengePageSizeState = useResetRecoilState(challengesPageSizeState)
  const resetChallengeSearchState = useResetRecoilState(termState)
  const resetTeamsPageState = useResetRecoilState(teamsPageState)
  const resetTeamsPageSizeState = useResetRecoilState(teamsPageSizeState)
  const doResetStates = useCallback(() => {
    resetTeamState()
    resetChallengeState()
    resetFilterTypeState()
    resetCategoryState()
    resetMonitorPageState()
    resetDashboardPageState()
    resetDashboardPageSizeState()
    resetLeaderboardStyleState()
    resetLeaderboardMetricState()
    resetChallengePageState()
    resetChallengePageSizeState()
    resetChallengeSearchState()
    resetTeamsPageState()
    resetTeamsPageSizeState()
  }, [
    resetTeamState,
    resetChallengeState,
    resetFilterTypeState,
    resetCategoryState,
    resetMonitorPageState,
    resetDashboardPageState,
    resetDashboardPageSizeState,
    resetLeaderboardStyleState,
    resetLeaderboardMetricState,
    resetChallengePageState,
    resetChallengePageSizeState,
    resetChallengeSearchState,
    resetTeamsPageState,
    resetTeamsPageSizeState,
  ])
  useEffect(() => {
    const { search } = window.location
    // Only handle route change when the search is empty (i.e. user clicks on the side navigation)
    if (search === "") {
        let cancelled = false
        const rafId = window.requestAnimationFrame(() => {
            if (cancelled) return
            doResetStates()
            onRouteChange && onRouteChange(location)
        })

        return () => {
            cancelled = true
            window.cancelAnimationFrame(rafId)
        }
    }
  }, [location, onRouteChange, doResetStates]);
};

export default useRouteChange